import { axiosInstance } from "@/utils/lib/axios";
import { QueryFunctionContext, useQuery } from "@tanstack/react-query";

import { RFSData } from "./rfs";

interface OPMEvidenceData {
  id: string;
  opmEvidenceFilename: string;
  opmEvidencePath: string;
  isValid: boolean;
  opmEvidenceType: "olt" | "activity" | "feeder" | "clamphook";
  rfs: RFSData;
}

interface OPMFDTQueryKey {
  rfsId: string;
}

async function getOpmEvidences(
  queryFunctionContext: QueryFunctionContext,
): Promise<OPMEvidenceData[]> {
  const { queryKey } = queryFunctionContext;
  const [_, opmFDTQueryKey] = queryKey;
  const { rfsId } = opmFDTQueryKey as OPMFDTQueryKey;

  const response = await axiosInstance.get(
    "/api/crud/opm-evidence" + `?rfs.id=${rfsId ?? ""}`,
  );
  return response.data.data.content;
}
function useOpmEvidences(opmFDTQueryKey: OPMFDTQueryKey) {
  const { rfsId } = opmFDTQueryKey;
  return useQuery({
    queryKey: ["opmEvidences", { rfsId }],
    queryFn: getOpmEvidences,
  });
}

export type { OPMEvidenceData };
export { useOpmEvidences };
